import { render, staticRenderFns } from "./PermissionList.vue?vue&type=template&id=dd3706a2&scoped=true&"
import script from "./PermissionList.vue?vue&type=script&lang=js&"
export * from "./PermissionList.vue?vue&type=script&lang=js&"
import style0 from "./PermissionList.vue?vue&type=style&index=0&id=dd3706a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3706a2",
  null
  
)

export default component.exports